import { Dialog, makeStyles, useMediaQuery, DialogContent, useTheme, DialogTitle, Typography, Button } from '@material-ui/core';
import React, { useEffect, useMemo, useState } from 'react';
import Lottie from 'react-lottie-player';

import animationData from "src/pages/ActionLayout/Finalize/anim_completion.json";

const useStyles = makeStyles((theme) => {
  return {
    root: {
      alignSelf: 'center',
      textAlign:'center',
      paddingBottom: theme.spacing(4)
    },
    lottie: {
      height: 200
    },
    content:{
      lineHeight: '2em',
      padding: theme.spacing(3)
    }
  }
})
const RebookingPopup = ({ open = false }) => {
  const classes = useStyles()

  const [isOpen, setIsOpen] = useState(true);

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog open={isOpen} maxWidth="xs" >
        <Lottie
          className={classes.lottie}
          play
          loop={0}
          animationData={animationData}
        />
      <DialogContent className={classes.root}>
        <Typography variant='h4'>
          You have rebooked successfully
        </Typography>
        <Typography variant='body1' className={classes.content}>
          You will be asked to confirm this new booking on the next screen to continue
          </Typography>
          <Button variant='contained' size="large" color='primary' onClick={() => setIsOpen(false)}>Okay</Button>
      </DialogContent>
    </Dialog>
  )
}

export { RebookingPopup }